
import type { ResourceAssignment } from "../types";

export const sortAssignmentsByHierarchy = (assignments: ResourceAssignment[]): ResourceAssignment[] => {
  // Define role hierarchy order
  const roleTypeOrder = {
    'project-director': 1,
    'project-manager': 2,
    'team-lead': 3,
    'team-member': 4
  };

  return assignments.sort((a, b) => {
    // First, sort by role type hierarchy
    const roleTypeA = a.role_type || 'team-member';
    const roleTypeB = b.role_type || 'team-member';
    
    const orderA = roleTypeOrder[roleTypeA as keyof typeof roleTypeOrder] || 5;
    const orderB = roleTypeOrder[roleTypeB as keyof typeof roleTypeOrder] || 5;
    
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    
    // If role types are the same, sort alphabetically by name
    const nameA = a.name || '';
    const nameB = b.name || '';
    return nameA.localeCompare(nameB);
  });
};
